import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Alert, Button, Col, InputGroup } from "react-bootstrap";
import moment from "moment-timezone";

import { get } from "../../../utils/DeApi";
import { exportFilings } from "../../../utils/exportUtils";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import FilingList from "../../Filing/FilingList/FilingList";

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    var startTime = new Date(props.filedAt);
    var endTime = new Date(startTime.getDate() + 1);
    var from = localStorage.getItem("_last_filter_from");
    var to = localStorage.getItem("_last_filter_to");
    this.state = {
      filings: [],
      catalogue: [],
      startTime: startTime.setHours(0),
      endTime: endTime.setHours(0),
      from: from,
      to: to,
      showFilters: from && to,
      searched: "",
      searchContainer: [],
    };
    this._handleInputChange = this._handleInputChange.bind(this);
    this.child = React.createRef();
  }

  componentDidMount() {
    this.searchFilings();
    this.fetchCatalogue();
    this.fetchSelections();
  }

  searchFilings() {
    const { query, filedAt } = this.props;
    // const { filedAt } = this.props;
    const { from, to, queryByFetch } = this.state;
    this.setState({ error: null, isLoading: true, filtered: from && to });
    localStorage.setItem("_last_search_q", query);
    localStorage.setItem("_last_search_d", filedAt);

    var searchFilingsPromise = null;
    if (queryByFetch) {
      searchFilingsPromise = get("/search/filings", {
        params: {
          q:
            `fetchedAtDate:${moment(filedAt).format("YYYY-MM-DD")}` +
            (query ? ` AND (${query})` : ""),
          offset: 0,
          limit: 5000,
        },
      });
    } else {
      const isDayLightSaving = moment(filedAt).tz("America/New_York").isDST();
      const timeFilterQuery =
        from && to
          ? `filedAt:[${filedAt}T${from || "00:00"}:00-${
              isDayLightSaving ? `04:00` : `05:00`
            } TO ${filedAt}T${to || "23:59"}:59-${
              isDayLightSaving ? `04:00` : `05:00`
            }]`
          : "";
      var q =
        query && timeFilterQuery
          ? `(${timeFilterQuery}) AND (${query})`
          : query
          ? query
          : timeFilterQuery;

      searchFilingsPromise = get("/search/filings", {
        params: { filedAt: filedAt, q: q || '""', offset: 0, limit: 5000 },
      });
    }

    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          filings: response.data,
          searchContainer: response.data,
          filingsMeta: response.meta,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({
            error: { message: error.code, code: error.code },
            isLoading: false,
          });
      });
  }

  fetchFilings(docs, filedAt) {
    if (!docs.length) {
      this.setState({
        filings: [],
        filingsMeta: { totals: 0 },
        error: null,
        isLoading: false,
      });
      return;
    }

    this.setState({ error: null, isLoading: true });
    const accessionNos = docs.map(
      (item) => 'accessionNo:"' + item.accessionNo + '"'
    );

    const filingsQuery = accessionNos.length ? accessionNos.join(" OR ") : '""';
    const searchFilingsPromise = get("/search/filings", {
      params: {
        filedAt: filedAt,
        q: filingsQuery,
        offset: 0,
        limit: 5000,
      },
    });
    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          filings: response.data,
          searchContainer: response.data,
          filingsMeta: response.meta,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
  }

  fetchSelections() {
    const { filedAt } = this.props;
    this.setState({ selectionsError: null, selectionsIsLoading: true });

    const selectionsPromise = get("/catalogues", {
      params: { filedAt: filedAt },
    });
    selectionsPromise.promise
      .then((response) => {
        this.setState({
          selections: response.data,
          selectionsError: null,
          selectionsIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ selectionsError: error, selectionsIsLoading: false });
      });
    this.subscribedPromises.push(selectionsPromise);
  }

  fetchCatalogue() {
    const { filedAt } = this.props;
    this.setState({ catalogueError: null, catalogueIsLoading: true });

    const cataloguesPromise = get("/catalogues", {
      params: {
        filedAt: filedAt,
        fromSection: "catalogue",
        inventories: [
          "609a925cd40db",
          "609a925ccd422",
          "609a925cc94f7",
          "609a925ccf235",
          "609a925cd1714",
        ],
      },
    });
    cataloguesPromise.promise
      .then((response) => {
        this.setState({
          catalogue: response.data,
          catalogueError: null,
          catalogueIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ catalogueError: error, catalogueIsLoading: false });
      });
    this.subscribedPromises.push(cataloguesPromise);
  }

  /* *** handle change function for the search-field *** */
  _handleInputChange(input) {
    if (input?.target?.value) {
      this.setState({ searched: input.target.value });
      this.search(input.target.value);
    } else {
      this.setState({ searched: "" }, () => {
        this.search();
      });
    }
  }

  /* *** filter filing collection for a search ( below ) *** */
  search(value = "") {
    const { searchContainer } = this.state;

    if (value !== null && value !== "") {
      this.setState({
        filings: searchContainer.filter((record) =>
          record.companyName.toLowerCase().includes(value.toLowerCase())
        ),
      });
    } else {
      this.setState({ filings: searchContainer });
    }
    if (this.child && this.child.current && this.child.current !== null) {
      this.child.current.updateStateData();
    }
  }

  _renderFilings() {
    const {
      filings,
      selections,
      catalogue,
      filingsMeta,
      searched,
      showFilters,
    } = this.state;
    if (filings.length) {
      return (
        <FilingList
          filings={filings}
          ref={this.child}
          filingsMeta={filingsMeta}
          catalogue={catalogue}
          btnShow={true}
          selections={selections || []}
          searcheValue={searched}
          onCatalogueAdd={(catalogued) => {
            this.setState({ selections: [...selections, ...[catalogued]] });
          }}
          onCatalogueRemove={(catalogued) => {
            this.setState({
              selections: selections.filter(
                (item) => item.id !== catalogued.id
              ),
            });
          }}
          queryByFetch={this.state.queryByFetch}
          sortable
          filtersVisibility={showFilters}
        />
      );
    }
    return (
      <Col>
        <Alert variant="info">
          <h4 className="mb-0">
            No relevant filings found for this search criteria.
          </h4>
        </Alert>
      </Col>
    );
  }

  render() {
    const { filings, filingsMeta, isLoading, error, selections, searched } =
      this.state;

    const { filedAt } = this.props;
    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    return (
      <>
        <div
          className="sticky"
          style={{
            width: "100%",
            height: "9%",
            zIndex: "100",
            paddingLeft: "1%",
          }}
          id="main_sticky"
        >
          <InputGroup.Append>
            {this.props.searchForm}

            <div
              className="input-group float-right col-xs-2"
              style={{ width: "35%", marginRight: "0%", height: "20%" }}
            >
              <input
                type="text"
                className="form-control roundedEdges"
                placeholder="Search Filings"
                onChange={this._handleInputChange}
                value={searched}
              />
            </div>
            <div className="float-right col-xs-2 floated-export">
              <a
                href="#"
                className="override-anchor-effect"
                style={{ zIndex: "1000" }}
                variant="outline-deal-style"
                size="xs"
                onClick={() => {
                  exportFilings(filings, filedAt + "-search-results.csv");
                }}
              >
                Export{" "}
                <span className="material-icons color-deal-style">
                  description
                </span>
              </a>
            </div>
          </InputGroup.Append>

          {this.renderFilters(selections, filedAt, filingsMeta)}
          {/* <span className="float-right">
            {filingsMeta && (<small> {filingsMeta.totals || 0} Files / {selections?.length || 0}{" "} Selected </small>)}{" "}
            <small>
              <Link className="btn btn-xs btn-outline-deal-style" to={`selections/${filedAt}`} >
                Selections: {moment(filedAt).format("MM/DD/YYYY")}
                <span className="material-icons md-18">arrow_forward</span>
              </Link>
            </small>
        </span> */}
        </div>
        {/*  */}
        {/* {filings.length ? (
          <FilingList
            filings={filings}
            filingsMeta={filingsMeta}
            btnShow={true}
            catalogue={catalogue}
            selections={selections}
            onCatalogueAdd={(catalogued) => {
              this.setState({ selections: [...selections, ...[catalogued]] });
            }}
            onCatalogueRemove={(catalogued) => {
              this.setState({
                selections: selections.filter(
                  (item) => item.id !== catalogued.id
                ),
              });
            }}
            queryByFetch={this.state.queryByFetch}
            sortable
            filtersVisibility={showFilters}
          />
        ) : (
          <Col>
            <Alert variant="info">
              <h4 className="mb-0">
                No relevant filings found for this search criteria.
              </h4>
            </Alert>
          </Col>
        )} */}
        {this._renderFilings()}
        {isLoading && <Loader />}
        {error && <ErrorHandler error={error} />}
      </>
    );
  }

  renderFilters(selections, filedAt, filingsMeta) {
    const { from, to, filtered } = this.state;
    var startTimes = [];
    for (let index = 0; index < 24; index++) {
      if (index < 10) startTimes.push(`0${index}:00`);
      else startTimes.push(`${index}:00`);
    }

    var endTimes = [];
    for (let index = 0; index < 24; index++) {
      if (index < 10) endTimes.push(`0${index}:59`);
      else endTimes.push(`${index}:59`);
    }
    return (
      <InputGroup.Append>
        <div className="mt-4 w-100">
          <div
            className="row d-flex float-right align-items-center"
            id="filters_control"
            style={{ paddingRight: "2%" }}
          >
            {/* <!-- Default switch --> */}
            <div className="float-right">
              <div className="custom-control custom-switch flow-control">
                <input
                  type="checkbox"
                  checked={this.state.queryByFetch}
                  className="custom-control-input"
                  id="customSwitches"
                  value={"queryByFetch"}
                  onChange={(ev) => {
                    this.setState(
                      { queryByFetch: !this.state.queryByFetch },
                      () => {
                        this.searchFilings();
                      }
                    );
                  }}
                  aria-label="select"
                />
                <label
                  className="custom-control-label"
                  htmlFor="customSwitches"
                >
                  Search by fetching date
                </label>
              </div>
            </div>
            <div className="flex flow-control" style={{ paddingLeft: "10px" }}>
              {filingsMeta && (
                <small>
                  <Link
                    className="btn btn-xs btn-outline-deal-style roundedEdges line-height"
                    to={`selections/${filedAt}`}
                  >
                    {filingsMeta.totals || 0} Files / {selections?.length || 0}{" "}
                    Selected
                    <span className="material-icons">arrow_forward</span>
                  </Link>
                </small>
              )}{" "}
              {/* <small>
              <Link className="btn btn-xs btn-outline-deal-style" to={`selections/${filedAt}`} >
                Selections: {moment(filedAt).format("MM/DD/YYYY")}
                <span className="material-icons">arrow_forward</span>
              </Link>
            </small> */}
            </div>
          </div>
          <div className="btn-group float-left">
            <span className="pt-2 mr-2 w-100">Filing Time:</span>
            <input
              className="form-control"
              type="time"
              style={{ borderRadius: "10px" }}
              id="from"
              name="from"
              min="00:00"
              max={to || "23:59"}
              value={from || ""}
              onChange={(ev) => {
                this.setState({ from: ev.target.value });
              }}
            />

            <span className="ml-2 mr-2 pt-1"> — </span>
            <input
              className="form-control"
              type="time"
              id="to"
              name="to"
              min={from || "00:00"}
              max="23:59"
              style={{ borderRadius: "10px" }}
              value={to || ""}
              onChange={(ev) => {
                this.setState({ to: ev.target.value });
              }}
            />

            <Button
              variant="default"
              style={{ height: "50%", borderRadius: "10px" }}
              className="ml-2 mr-2 btn-outline-deal-style"
              disabled={!to || !from}
              onClick={() => {
                localStorage.setItem("_last_filter_from", from);
                localStorage.setItem("_last_filter_to", to);
                this.searchFilings();
              }}
            >
              Submit
            </Button>
            <Button
              size="sm"
              variant="default"
              style={{ height: "100%", marginTop: "0.6%" }}
              className="mr-2 btn-success-deal-style"
              disabled={!filtered}
              onClick={() => {
                this.setState(
                  { to: null, from: null, filtered: false, showFilters: false },
                  () => {
                    localStorage.removeItem("_last_filter_from", from);
                    localStorage.removeItem("_last_filter_to", to);
                    this.searchFilings();
                  }
                );
              }}
            >
              <span className="material-icons md-18">clear</span>
            </Button>
          </div>
        </div>
      </InputGroup.Append>
    );
  }
}
SearchResults.propTypes = {
  filedAt: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
};

export default SearchResults;
